import React from 'react'

export default function CreatedPackagesEnquiryList() {
  return (
    <div>
      CreatedPackagesEnquiryList
    </div>
  )
}
